import React from 'react'
import { Image, Card, Grid } from 'semantic-ui-react';
import './styles.css';

class WelcomeCard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        return (
            <Card className="w_100 text-left">
                <Card.Content>
                    <Grid>
                        <Grid.Row className="pad_0">
                            <Grid.Column width={this.props.extra ? 8 : 16} >
                                <Grid>
                                    <Grid.Row className="pad_0">
                                        <Grid.Column style={{ height: "90px", width: "90px" }} className="pad_0">
                                            <Image src={this.props.image} />
                                        </Grid.Column>
                                        <Grid.Column style={{ width: "calc(100% - 110px)", margin: "0 0 0 15px" }} className="pad_0">
                                            <Card.Header><strong>{this.props.head}</strong></Card.Header>
                                            <Card.Description>
                                                {this.props.subHead}<br /><br />
                                            </Card.Description>
                                            <Card.Description>
                                                {this.props.button}
                                            </Card.Description>
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Grid.Column>
                            {this.props.extra ?
                                <Grid.Column width={8} >
                                    {this.props.extra}
                                </Grid.Column> : null
                            }
                        </Grid.Row>
                    </Grid>
                </Card.Content>
            </Card>
        )
    }
}

export default WelcomeCard;


